import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import NiceSelect from '../Header/NiceSelect';
import { api } from '../../services/api';

function ContactOne() {
    const [form, setForm] = useState({ name: '', email: '', tour_interest: '', message: '' });
    const [status, setStatus] = useState({ type: '', text: '' });
    const [submitting, setSubmitting] = useState(false);

    const tourOptions = [
        { value: "Africa Adventure", label: "Africa Adventure" },
        { value: "Africa Wild", label: "Africa Wild" },
        { value: "Asia", label: "Asia" },
        { value: "Scandinavia", label: "Scandinavia" },
        { value: "Western Europe", label: "Western Europe" },
    ];

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setStatus({ type: '', text: '' });
        try {
            await api.submitContact(form);
            setStatus({ type: 'success', text: 'Message sent successfully!' });
            setForm({ name: '', email: '', tour_interest: '', message: '' });
        } catch (err) {
            setStatus({ type: 'error', text: err.message });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="contact-area3 bg-top-center  overflow-hidden"
            style={{ backgroundImage: "url(/assets/img/bg/contact_bg_1.jpg)", backgroundRepeat: "no-repeat" }}
        >
            <div className="container">
                <div className="row gy-4 justify-content-between align-items-center">
                    <div className="col-lg-5">
                        <div className="pt-80 p-lg-0">
                            <div className="title-area pe-xl-5">
                                <span className="sub-title text-white">Get in touch</span>
                                <h2 className="sec-title text-white">Say hello to us</h2>
                                <p className="contact-text text-white">
                                    We’love to hear from you. Our friendly team is always here to chat
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="contact-form-area">
                            <form onSubmit={handleSubmit} className="contact-form2 ajax-contact">
                                <div className="row">
                                    <div className="form-group col-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            id="name3"
                                            placeholder="First Name"
                                            value={form.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <img src="/assets/img/icon/user.svg" alt="" />
                                    </div>
                                    <div className="form-group col-12">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            id="email3"
                                            placeholder="Your Mail"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        <img src="/assets/img/icon/mail.svg" alt="" />
                                    </div>
                                    <div className="form-group col-12">
                                        <select
                                            className="form-control"
                                            name="tour_interest"
                                            value={form.tour_interest}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Tour Type</option>
                                            {tourOptions.map((opt) => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group col-12">
                                        <textarea
                                            name="message"
                                            id="message"
                                            cols={30}
                                            rows={3}
                                            className="form-control"
                                            placeholder="Your Message"
                                            value={form.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <img src="/assets/img/icon/chat.svg" alt="" />
                                    </div>
                                </div>
                                {status.text && (
                                    <p className={`form-messages mb-0 mt-3 ${status.type === 'error' ? 'text-danger' : 'text-success'}`}>
                                        {status.text}
                                    </p>
                                )}
                                <div className="form-btn-wrapp">
                                    <div className="form-btn">
                                        <button type="submit" className="th-btn white-btn" disabled={submitting}>
                                            {submitting ? 'Sending...' : 'Send Message'} <img src="/assets/img/icon/plane3.svg" alt="" />
                                        </button>
                                    </div>
                                    <div className="contact-info">
                                        <p className="contact-info_link">
                                            <Link to="tel:+0123456789">+012 345 6789</Link>
                                        </p>
                                        <div className="contact-info_icon">
                                            <Link to="tel:+0123456789">
                                                <img src="/assets/img/icon/call.svg" alt="" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactOne
